//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Las props de accesibilidad son opt-in: con sus valores por defecto el diálogo se
// comporta igual que antes (persistent, Escape no cierra, foco en el contenedor).
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    custom_title: {
      type: Boolean,
      required: false,
      default: false
    },
    // Clases de la barra de título. `dialog-title--plain` (theme.scss) la deja blanca.
    titleClass: {
      type: String,
      default: 'grey lighten-3'
    },
    // `alertdialog` para confirmaciones destructivas. Reemplaza el `role="dialog"`
    // que Vuetify pone en el contenedor.
    role: {
      type: String,
      default: ''
    },
    // ids de los elementos que nombran y describen el diálogo.
    ariaLabelledby: {
      type: String,
      default: ''
    },
    ariaDescribedby: {
      type: String,
      default: ''
    },
    // Selector CSS del elemento que recibe el foco al abrir (por ejemplo la acción
    // segura de una confirmación). Vacío: Vuetify enfoca el contenedor.
    initialFocus: {
      type: String,
      default: ''
    },
    // Escape cierra como la X. El clic fuera sigue sin cerrar (persistent).
    escToClose: {
      type: Boolean,
      default: false
    },
    // false oculta la X; sirve para impedir el cierre mientras algo se envía.
    closable: {
      type: Boolean,
      default: true
    },
    closeLabel: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  watch: {
    isOpen: function isOpen(open) {
      if (open) this.afterOpen();
    }
  },
  methods: {
    onClose: function onClose() {
      this.isOpen = false;
      this.$emit("onCloseClick");
    },
    onOpen: function onOpen() {
      this.isOpen = true;
    },
    onKeydown: function onKeydown(e) {
      // keyCode 27 = Escape. Si hay un menú o un select abierto dentro, Vuetify lo
      // cierra primero y el evento no llega como Escape del diálogo.
      if (this.escToClose && this.closable && e && e.keyCode === 27) {
        this.onClose();
      }
    },
    // VDialog enfoca su contenedor dos nextTick después de abrir; el foco inicial
    // propio va después de eso para no ser pisado.
    afterOpen: function afterOpen() {
      var _this = this;
      this.$nextTick(function () {
        _this.$nextTick(function () {
          _this.applyAria();
          if (!_this.initialFocus) return;
          window.requestAnimationFrame(function () {
            var dialog = _this.$refs.dialog;
            var root = dialog && dialog.$refs && dialog.$refs.dialog;
            var target = root && root.querySelector(_this.initialFocus);
            if (target) target.focus();
          });
        });
      });
    },
    applyAria: function applyAria() {
      var dialog = this.$refs.dialog;
      var content = dialog && dialog.$refs && dialog.$refs.content;
      if (!content) return;
      if (this.role) content.setAttribute('role', this.role);
      if (this.ariaLabelledby) content.setAttribute('aria-labelledby', this.ariaLabelledby);
      if (this.ariaDescribedby) content.setAttribute('aria-describedby', this.ariaDescribedby);
    }
  }
};